import React, { Component } from 'react';
import { Redirect, Link } from "react-router-dom";
import {SessionContext} from './SessionContext.js';
import NslMailAPI from '../NslMailAPI.js';

class LoginForm extends Component {
    static contextType = SessionContext;

    state = this.initialState = {username: "", password: "", error: null};

    async componentDidMount() {
      this.API = this.context.actions.getAPI?.() || new NslMailAPI(null);
    }

    async handleSubmit(e) {
      e.preventDefault();
      this.setState({error: null});
      try {
        let accessToken = await this.API.login(this.state.username, this.state.password);
        await this.context.actions.setAccessToken(accessToken);
        this.setState({redirect: '/aliases'});
      } catch (err) {
        // Keep the username so a mistyped password doesn't mean retyping both.
        this.setState({password: "", error: err.message || 'Unable to sign in.'});
      }
    }
    handleSubmit = this.handleSubmit.bind(this);
  
    render() {
      if (this.state.redirect) {
        return <Redirect to={this.state.redirect} />
      } else {
        return <div className="container-sm">
            <form onSubmit={this.handleSubmit} className="card">
              <div className="card-header">
                <h2 className="text-center text-xl font-semibold text-primary-600" style={{margin: 0}}>
                  Sign In to Your Account
                </h2>
              </div>
              <div className="card-content">
                {this.state.error && (
                  <div className="bg-red-50 border border-red-300 rounded-lg p-4 mb-6">
                    <p className="text-error-500" style={{margin: 0}}>{this.state.error}</p>
                  </div>
                )}
                <div className="form-group">
                  <label className="form-label">Username</label>
                  <input 
                    value={this.state.username} 
                    type="text" 
                    className="form-input"
                    placeholder="Enter your username"
                    onChange={(e) => {this.setState({username: e.target.value})}}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Password</label>
                  <input 
                    value={this.state.password} 
                    type="password" 
                    className="form-input"
                    placeholder="Enter your password"
                    onChange={(e) => {this.setState({password: e.target.value})}}
                  />
                  <div className="mt-2">
                    <Link 
                      to="/forgot-password" 
                      className="text-sm text-gray-500"
                      style={{
                        color: "var(--gray-500)", 
                        textDecoration: "none",
                        fontSize: "var(--font-size-sm)"
                      }}
                    >
                      Forgot your password?
                    </Link>
                  </div>
                </div>
                <div className="flex gap-4 justify-center mt-6">
                  <button type="submit" className="btn btn-primary btn-lg">
                    Sign In
                  </button>
                  <Link to="/new-account" className="btn btn-secondary btn-lg">
                    Create Account
                  </Link>
                </div>
              </div>
            </form>
          </div>;
      }
    }
  }

  export default LoginForm;